<template>
    <div class="self-stretch flex flex-col justify-start items-center gap-8 ">
      <!-- Title Section -->
      <div class="self-stretch flex flex-col justify-start items-start gap-6">
        <div class="self-stretch flex flex-col justify-start items-center gap-2">
          <div class="self-stretch flex flex-col justify-start items-center gap-1">
            <div class="self-stretch justify-start text-white text-2xl font-bold font-['Inter'] leading-[30px]">
              <div class="agreement-disclaimer text-lg font-bold font-['Inter']" v-if="!signup">
                {{ $t('common_check_agree')}} <br><a :href="termsOfUseUrl" target="_blank">{{ $t('terms_of_use') }} {{ $t('common_and') }} {{ $t('support_privacy_title')}}</a>
              </div>
              <div
                ref="agreementScroll"
                class="h-72 scrollbar-thumb-rounded-full scrollbar-thin scrollbar-track-rounded-full scrollbar scrollbar-thumb-[#f0f6ff57] scrollbar-track-transparent overflow-y-scroll"
                v-else
                @scroll="onAgreementScroll"
              >
                <terms-inc></terms-inc>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Buttons Section -->
      <div class="self-stretch flex flex-col justify-start items-start gap-3">
        <button
            @click="acceptAgreements"
            type="button"
            value="Accept"
            :disabled="!canAcceptAgreement"
            class="self-stretch px-5 py-2.5 bg-[#6CBFFF] hover:bg-opacity-10 rounded-xl inline-flex justify-center items-center gap-2 overflow-hidden transition duration-160 cursor-pointer"
        >
          <div class="justify-start text-black text-base font-medium font-['Inter'] leading-normal">
            {{ $t('common_accept') }}
          </div>
        </button>
        <div @click="selfClose" class="self-stretch text-[#6CBFFF] text-base leading-[1.2rem] font-inter mt-5 mb-2 text-center cursor-pointer">
          {{ $t('common_cancel') || 'Cancel' }}
        </div>
      </div>
    </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex';
import TermsInc from "@/components/includes/regionTermsInc";
import emitter from "@/services/emitter.service";
import { Constants } from '@/cfg/constants';

export default {
  name: 'AgreementModal',
  props: {
    signup: {
      type: Boolean,
      required: false,
      default: false,
    },
    nextEvent: {
      type: String,
      required: false,
      default: 'open-auth0',
    }
  },
  components: {
    TermsInc
  },
  data() {
    return {
      termsShow: false,
      privacyShow: false,
      canAcceptAgreement: true,
    }
  },
  methods: {
    onAgreementScroll() {
      // No-op: accept button is no longer gated on scroll position.
    },
    evaluateAgreementScrollState() {
      this.canAcceptAgreement = true;
    },
    acceptAgreements() {
      if (!this.canAcceptAgreement) {
        return;
      }

      if (!this.authorized) {
        this.$store.commit('nonpersist/setGuestAgreed', true);
        this.$store.commit('auth/setPreAuthTosAccepted', true);
      } else {
        this.$store.commit("auth/setAgreed", true);
        console.log('setting pre auth tos accepted to true');
        this.$store.commit('auth/setPreAuthTosAccepted', true);
      }
      this.$emitter.emit('modalClose');
      emitter.emit(this.nextEvent);
    },
    selfClose() {
      this.$store.commit('auth/setPreAuthTosAccepted', false);
      this.$emitter.emit('modalClose');
    },
  },
  computed: {
    ...mapState('auth', ['token', 'authorized', 'agreed', 'accountType']),
    ...mapState('nonpersist', ['guestAgreed']),
    termsOfUseUrl() {
      return Constants.REGION_CONFIG.termsUrl;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.evaluateAgreementScrollState();
    });
  }
}
</script>

<style lang="scss">
  .agreement__container {
    font-family: 'Inter', sans-serif;
    position: relative;

    @media all and (max-width: 1100px) {
      position: fixed;
      top: 0;
      width: 100% !important;
      height: 100% !important;
      z-index: 10000;
      border-radius: 0 !important;
    }
  }

  .agreement-disclaimer {
    text-align: center;
    color: #FFFFFF;

    a {
      color: #6CBFFF;
      text-decoration: underline;
    }

    @media all and (max-width: 1100px) {
      font-size: 1.3rem;
      line-height: 1.5rem;
    }
  }

  .agreement-links {
    margin-top: 40px;
    margin-bottom: 65px;
    border-top: 1px solid #505050;
    display: flex;
    flex-direction: column;
    width: 100%;

    a {
      display: flex;
      font-weight: 400;
      font-size: 1rem;
      line-height: 22px;
      height: 44px;
      width: 100%;
      align-items: center;
      /* identical to box height, or 138% */
      text-transform: capitalize;
      color: #6CBFFF;
      border-bottom: 1px solid #505050;
      padding-left: 15px;
      background: url(@/assets/icons/arrow-r.svg) 90% center no-repeat;

      @media all and (max-width: 1100px) {
        font-size: 1.3rem;
      }
    }
  }

  .custom-checkbox {
    cursor: pointer;
    display: flex !important;

    input {
      position: absolute;
      opacity: 0;
    }

    .checkmark {
      height: 36px;
      flex-basis: 36px;
      flex-grow: 0;
      flex-shrink: 0;
      background: #515151;
      border: 2px solid #EAEAEA;
      border-radius: 5px;
      margin-right: 14px;
    }

    input:checked + .checkmark {
      background: #515151 url(@/assets/icons/checkmark.svg) center center no-repeat;
    }

    &__label {
      font-weight: 400;
      font-size: 0.9rem;
      line-height: 1.125rem;

      color: #FFFFFF;
      text-transform: none;

      @media all and (max-width: 1100px) {
        font-size: 1.2rem;
        line-height: 1.4rem;
      }
    }
  }

  .scrolledView {
    
    width: 800px;

    .textview-wrap {
      height: 460px;
      overflow: auto;
      max-width: 100%;
    }

    .text-content {
      padding-right: 25px;
    }

    @media all and (max-width: 1100px) {
      .conference-close {
        display: none;
      }

      .text-content {
        padding-right: 0;
        font-size: 14px;
      }
    }
  }

  .agreement__close {
    position: absolute;
    right: 20px;
    top: 20px;
    display: block;
    width: 25px;

    img {
      max-width: 100%;
    }

    @media all and (max-width: 1100px) {
      width: 33px;
      height: 33px;
      top: 5%;
      right: 5%;
    }
  }

  .conference {
    .agreement__container {
      margin: auto;

      .conference-close {
        position: absolute;
        top: -7%;
        right: -7%;

        @media all and (max-width: 1100px) {
          top: 5%;
          right: 5%;
          position: absolute;
        }
      }
    }
  }

  .agreement-form form {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

</style>
